'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getClassName = function getClassName(inline, styled, className, use) {
  return (0, _classNames2.default)('uiList', {
    'private-list--inline': inline,
    'private-list--inline-divided': use === 'inline-divided',
    'private-list--unstyled': !styled
  }, className);
};

var renderItems = function renderItems(children, childClassName, firstChildClassName, lastChildClassName) {
  return _react.Children.map(children, function (child, i) {
    if (child == null) {
      return null;
    }

    var computedChildClassName = void 0;
    if (i === 0 && firstChildClassName != null) {
      computedChildClassName = firstChildClassName;
    } else if (i === children.length - 1 && lastChildClassName != null) {
      computedChildClassName = lastChildClassName;
    } else {
      computedChildClassName = childClassName;
    }

    var className = (0, _classNames2.default)('uiListItem', 'private-list__item', computedChildClassName);

    return _react2.default.createElement(
      'li',
      { className: className },
      child
    );
  });
};

var renderOrdered = function renderOrdered(rest, computedClassName, renderedItems) {
  return _react2.default.createElement(
    'ol',
    _extends({}, rest, { className: computedClassName }),
    renderedItems
  );
};

var renderUnordered = function renderUnordered(rest, computedClassName, renderedItems) {
  return _react2.default.createElement(
    'ul',
    _extends({}, rest, { className: computedClassName }),
    renderedItems
  );
};

exports.default = _react2.default.createClass({
  displayName: 'UIList',

  propTypes: {
    childClassName: _react.PropTypes.string,
    children: _react.PropTypes.node,
    firstChildClassName: _react.PropTypes.string,
    inline: _react.PropTypes.bool.isRequired,
    lastChildClassName: _react.PropTypes.string,
    ordered: _react.PropTypes.bool.isRequired,
    styled: _react.PropTypes.bool.isRequired,
    use: _react.PropTypes.oneOf(['default', 'inline-divided'])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      inline: false,
      ordered: false,
      styled: false,
      childClassName: '',
      use: 'default'
    };
  },
  render: function render() {
    var _props = this.props,
        ordered = _props.ordered,
        styled = _props.styled,
        inline = _props.inline,
        className = _props.className,
        children = _props.children,
        childClassName = _props.childClassName,
        firstChildClassName = _props.firstChildClassName,
        lastChildClassName = _props.lastChildClassName,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['ordered', 'styled', 'inline', 'className', 'children', 'childClassName', 'firstChildClassName', 'lastChildClassName', 'use']);

    var computedClassName = getClassName(inline, styled, className, use);
    var renderedItems = renderItems(children, childClassName, firstChildClassName, lastChildClassName);

    if (use === 'inline-divided' && !inline) {
      _devLogger2.default.warn({
        message: 'UIList: `inline` needs to be `true` when `use="inline-divided"` is set',
        key: 'UIList: use inline-divided requires inline'
      });
    }

    if (ordered) {
      return renderOrdered(rest, computedClassName, renderedItems);
    }
    return renderUnordered(rest, computedClassName, renderedItems);
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/list/UIList.js
// module id = 532
// module chunks = 171